import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2StyleListLocalResponse {
  results: Array<Results>;
  total: number;
  page: number;
  page_size: number;
};

export interface Results {
  id: number;
  style_id: string;
  name: string;
  cover_url: string;
  scene: string;
  profession: Profession;
  created_at_time: Date;
  demo_url: string;
  video_struct_info?: string;
  author_info: Author_info;
  sid: string;
  db_created_at: number;
  updated_at: number;
  deleted_at?: string;
};

export interface Profession {
  id: string;
  name: string;
};

export interface Author_info {
  avatar: string;
  name: string;
};


// 请求接口
export interface AgentV2StyleListLocalRequest {
  styleId: string,
  page: number,
  pageSize: number
  agentId?: string;
}

export class StyleData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id?: number;

  @Required("Style id cannot be empty")
  @IsString("Style id must be a string")
  styleId: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Cover url cannot be empty")
  @IsString("Cover url must be a string")
  coverUrl: string;

  @IsNumber("templateResource must be a number")
  templateResource?: number;

  @Required("Demo url cannot be empty")
  @IsString("Demo url must be a string")
  demoUrl: string;

  // @Required("Scene cannot be empty")
  @IsString("Scene must be a string")
  scene: string;
}

export class AgentV2StyleListLocalData {
  @IsArray("List must be an array")
  results: StyleData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateAgent = (
  response: AgentV2StyleListLocalResponse
): AgentV2StyleListLocalData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2StyleListLocalData);
  } catch (error) {
    console.error("Agent V2 Style List Local data validation failed:", error.message);
    throw error;
  }
};

/** 本地风格列表 */
export const agentV2StyleListLocal = async ({
  page,
  pageSize,
  styleId,
  agentId,
}: AgentV2StyleListLocalRequest): Promise<AgentV2StyleListLocalData> => {
  const response = await api.post<AgentV2StyleListLocalResponse>('/agent-v2/style-list-local', {
    page,
    page_size: pageSize,
    style_id: styleId,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
